<template>
  <el-dialog title="点检项详情" append-to-body :close-on-click-modal="false" :visible="visible" width="1000px"
    :before-close="closeDialog">
    <commonTable :tableData="tableData" :loading="loading" :paginationVisible="false">
      <template v-slot:table>
        <el-table-column
            align="center"
            type="index"
            label="序号"
            width="60"
        ></el-table-column>
        <el-table-column prop="title" align="center" label="项目" />
        <el-table-column align="center"  prop="timeCycle" label="周期">
          <template slot-scope="scope">
            <span v-if="0==scope.row.timeCycle">一次/天</span>
            <span v-if="1==scope.row.timeCycle">一次/周</span>
          </template>
        </el-table-column>
        <el-table-column prop="standard" align="center" label="标准" />
        <el-table-column prop="createTime" align="center" label="时间" />
        <el-table-column align="center"  prop="state" label="结果">
          <template slot-scope="scope">
            <span v-if="0==scope.row.state">正常</span>
            <span v-if="1==scope.row.state">异常</span>
            <span v-if="2==scope.row.state">停机</span>
            <span v-if="3==scope.row.state">待修</span>
          </template>
        </el-table-column>
    </template>
    </commonTable>
  </el-dialog>
</template>
<script>
import commonTable from "@/components/common/commonTable";
export default {
  components: {
      commonTable,
    },
  data() {
    return {
      visible: false,
      tableData: [],
      loading:false
    }
  },
  methods: {
    openDialog(item) {
      this.visible = true
      this.tableData = item
    },
    closeDialog() {
      this.visible = false
    }
  }
}
</script>
<style scoped>
.myImg {
  width: 80px;
  height: 80px;
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.conImg{
  width: 50px;
}
.cItem{
  display: flex;
}
</style>
